import * as React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

import professor from '~/images/prof.png';

import { useAuthSelector } from '../containers/Auth';
import Button from './Button';
import Modal from './Modal';

const HOST = window.location.host;

const ModalContent = styled.div`
  & * {
    font: revert;
  }

  line-height: 30px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 150px;
  }
`;

function AlreadyEnabledModal() {
  const alreadyEnabled = useAuthSelector((state) => state.matches('alreadyEnabled'));

  const goToHost = React.useCallback(() => {
    window.location.replace('/');
  }, []);

  return (
    <Modal isOpen={alreadyEnabled} withClose={false} onClose={() => {}}>
      <ModalContent>
        <img src={professor} alt="Real Geeks professor logo" />
        <h3>Looks like your site is already enabled</h3>
        <p>
          Go back to&nbsp;
          {HOST}
          &nbsp;to use the Realgeeks Facebook Ad Tool.
        </p>
        <Button
          size="lg"
          onClick={goToHost}
          css={css`
            margin: 20px auto;
          `}
        >
          Navigate to&nbsp;
          {HOST}
        </Button>
      </ModalContent>
    </Modal>
  );
}

export default AlreadyEnabledModal;
